<form [formGroup]="skjema" novalidate (submit)="lagre()">
  <mat-toolbar color="primary">
    <span>{{ "Importer aksjeeierbok for {navn} - {orgnr}" | translate:{navn: modell().skatteetatenModell()?.orgnavn, orgnr: modell().skatteetatenModell()?.orgnummer} }}</span>
    <button mat-icon-button mat-dialog-close class="example-icon" aria-label="Lukk dialog">
      <mat-icon fontSet="ion-ios-close-empty" class="mat-icon--ionic-ikon"/>
    </button>
  </mat-toolbar>

  <mat-dialog-content #skjemaKontainer>
    <opprett-aksjeeiere-fra-skatteetaten-liste [modell]="modell()"/>
  </mat-dialog-content>

  <mat-dialog-actions align="center" >
    <div class="scrollvarsel" [visDersomIkkeScrolletTilBunn]="skjemaKontainer" klasseNaarSynlig="scrollvarsel-synlig"><span>{{'Scroll ned for å se resten av skjemaet...' | translate}}</span></div>
    <button mat-button mat-dialog-close [disabled]="modell().redigererRad()">{{ "Avbryt" | translate }}</button>
    <button mat-raised-button color="primary" type="submit" [disabled]="modell().skjema.invalid || modell().redigererRad() || lagrer()" [visSpinner]="lagrer()">{{ "Registrer" | translate }}</button>
  </mat-dialog-actions>

</form>

